export default __webpack_public_path__ + "static/media/LogoAMP-removebg.a9a821a1.png";